export function formatCurrency(
  value,
  currency = "EUR",
  maximumFractionDigits = 0
) {
  if (value === null || value === undefined || value === "") {
    return "N/C";
  }

  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency,
    maximumFractionDigits
  }).format(Number(value));
}

export function formatPercent(value, maximumFractionDigits = 2) {
  if (value === null || value === undefined || value === "") {
    return "N/C";
  }

  return new Intl.NumberFormat("fr-FR", {
    style: "percent",
    maximumFractionDigits
  }).format(Number(value) / 100);
}

export function formatDate(value) {
  if (!value) return "N/C";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }).format(new Date(value));
}

export function formatDuration(months) {
  if (!months) return "N/C";
  return `${months} mois`;
}
